import { ServiceCard } from '@/components/orders/ServiceCard'
import { Order } from '@/types'
import { router } from '@inertiajs/react'
import { Box, Button, Divider, Group, Stack, Text } from '@mantine/core'

export function ArticlesList({ order, organizationSlug }: { order: Order; organizationSlug: string }) {
  const articlesCount = order.articles.length

  return (
    <Stack gap="xl">
      {order.articles.map((item, index) => {
        const goToArticleDetails = () =>
          router.visit(`/organizations/${organizationSlug}/orders/${order.id}/articles/${item.id}`)

        return (
          <Box key={item.id}>
            <Group mb="md" justify="space-between">
              <div>
                <Text fw={900} size="xl" style={{ textTransform: 'uppercase' }}>
                  {item.article_name}
                  {articlesCount > 1 && ` (${index + 1}/${articlesCount})`}
                </Text>
                {item.reference && (
                  <Text size="sm" c="dimmed">
                    Réf : {item.reference}
                  </Text>
                )}
              </div>
              <Button variant="subtle" size="xs" onClick={goToArticleDetails}>
                Détails
              </Button>
            </Group>
            <Stack gap="sm">
              {item.services.map((service) => (
                <ServiceCard key={service.id} service={service} />
              ))}
            </Stack>
            <Divider mt="xl" variant="dashed" />
          </Box>
        )
      })}

      <Group justify="flex-end" mt="xl">
        <Text size="xl" fw={900}>
          TOTAL : {order.price}€
        </Text>
      </Group>
    </Stack>
  )
}
